export default {
  id: 34,
  title: 'Target #34 - Christmas Tree',
  url: 'https://cssbattle.dev/play/34',
  colors: ['#007065', '#FFEECF', '#F5C181', '#00A79D'],
  solution:
    '<a a><a b><a c><style>body{background:#007065}a{position:fixed;left:75;width:250;height:100;clip-path:polygon(50% 0,0 100%,100% 100%)}a[a]{top:150;background:#00a79d}a[b]{top:100;background:#f5c181}a[c]{top:50;background:#ffeecf}</style>',
}
